"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var parameterize = function parameterize(obj, prefix) {
  var str = [];

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var value = obj[key];

      if (value !== undefined && value !== null && value !== "") {
        if (prefix) {
          key = prefix + "[" + key + "]";
        }

        if (Array.isArray(value)) {
          value = value.map(function (v) {
            return maybeEncode(v);
          });

          if (value.length > 0) {
            str.push(key + "=" + value.join(","));
          }
        } else if (_typeof(value) === "object") {
          str.push(parameterize(value, key));
        } else {
          str.push(key + "=" + maybeEncode(value));
        }
      }
    }
  } // remove blanks


  str = str.filter(function (p) {
    return !!p;
  });
  return str.join("&");
};

exports.default = parameterize; // IE does not encode by default like other browsers

var maybeEncode = function maybeEncode(value) {
  var isBrowser = typeof window !== "undefined";
  var isIE = isBrowser && window.navigator.userAgent.match(/(MSIE|Trident)/);
  var isEncoded = typeof value === "string" && value.indexOf("%") !== -1;
  var shouldEncode = isBrowser && isIE && !isEncoded;
  return shouldEncode ? encodeURIComponent(value) : value;
};